module.exports = __webpack_public_path__ + "static/media/dead_lift-01.f03ce789.png";